import { useState } from 'react';
import { EmployeeType } from '@prisma/client';
import { Button, Card, Descriptions, Tag } from 'antd';

import { Role } from '@app/domain-interfaces';
import { Auth } from '@app/web-components';

import { useEmployeeTypeTag } from '../../common';
import { useFindBundleById } from '../data';
import { ProductFamilyHierarchyPopover } from '../modals';

export const BundleCard = ({ bundleId }: { bundleId: number }) => {
  const { user } = Auth.useUserAuth();
  const { data: bundle, isPending } = useFindBundleById({ bundleId });
  const [show, setShow] = useState(false);

  const { getProps } = useEmployeeTypeTag(bundle?.employeeType as EmployeeType);

  return (
    <Card
      extra={
        <Button type="link" onClick={() => setShow((value) => !value)}>
          {show ? 'Less' : 'More'}
        </Button>
      }
      loading={isPending}
      size="small"
      title="Bundle"
    >
      {show ? (
        <Descriptions
          bordered
          column={1}
          items={[
            {
              key: 'name',
              label: 'Name',
              children: (
                <span>
                  {bundle?.name} <Tag {...getProps({ style: { marginLeft: '1em' } })} />
                </span>
              ),
            },
            {
              key: 'product-family',
              label: 'Product Family',
              children:
                user?.roles[Role.BUNDLE_ADMIN] || user?.roles[Role.RULE_ADMIN] ? (
                  <ProductFamilyHierarchyPopover
                    productFamilyId={bundle?.productFamily?.id}
                    productFamilyName={bundle?.productFamily?.name}
                  >
                    <Button type="link" size="small" style={{ padding: 0 }}>
                      {bundle?.productFamily?.name}
                    </Button>
                  </ProductFamilyHierarchyPopover>
                ) : (
                  bundle?.productFamily?.name
                ),
            },
            {
              key: 'owners',
              label: 'Owners',
              children: (
                <ul style={{ listStyleType: 'none', padding: 0 }}>
                  {bundle?.owners?.map((x) => (
                    <li>
                      <a href={`mailto:${x.owner.email}`}>{x.owner.name}</a>
                    </li>
                  ))}
                </ul>
              ),
            },
          ]}
          size="small"
        />
      ) : (
        <span>
          {bundle?.name} <Tag {...getProps({ style: { marginLeft: '1em' } })} />
        </span>
      )}
    </Card>
  );
};
